import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14ce7a40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "header__skeleton-text" }, "Вернуться на сайт", -1))
const _hoisted_4 = ["href"]

import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { FLogout } from '@/features/FLogout'
import { useUser } from '@/shared/composables'
import { getDateDistance } from '@/shared/utils'
import { useScreen } from 'vue-screen'
import IconTemplate from '@/apps/components/IconTemplate.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const screen = useScreen()
const isMobile = computed(() => {
  return screen.width < 768 // Set breakpoint for mobile devices
})

const landingLink = ref<string>()

const router = useRouter()
const route = useRoute()

const { isAuth } = useUser()

const { user } = useUser()

const isSubscriptionEnded = computed(
  () =>
    !getDateDistance(user.value.organization.block_at) ||
    !user.value.organization.package_count
)

const isAuthPage = computed(() => isAuth.value)

const currentMode = computed(() =>
  route.name === 'StatisticPage' ? 'statistic' : 'reports'
)
const isAdmin = computed((): boolean => user.value.role === 'admin')

const currentAdminMode = computed(() =>
  route.path.includes('/organizations') ? 'organizations' : 'users'
)

const handleToggleMode = (mode: string): void => {
  if (mode === 'statistic') {
    router.push({ name: 'StatisticPage' })
  } else {
    router.push({ name: 'PatientListingPage' })
  }
}

const handleToggleAdminMode = (mode: string) => {
  if (mode === 'users') {
    router.push({ name: 'UserListingPage' })
  } else {
    router.push({ name: 'AllOrganizationsPage' })
  }
}

const handleOpenReportCreationPage = (): void => {
  router.push({
    name: 'ReportCreationPage',
    params: { patientId: 'null-patient' },
  })
}

const handleOpenPatientCreationPage = (): void => {
  router.push({ name: 'PatientCreationPage' })
}

const handleOpenDoctorCreationPage = (): void => {
  router.push({ name: 'UserCreationPage' })
}

const handleCreateOrganization = (): void => {
  router.push('/admin/organizations/create')
}

const handleOpenSettings = (): void => {
  router.push({ name: 'SettingsPage' })
}

const handleOpenReportList = (): void => {
  router.push({ name: 'ReportsPage', query: { page: 1 } })
}

onMounted(() => {
  landingLink.value = window.origin
})

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_skeleton, {
      loading: !_unref(isAuthPage),
      class: "header__skeleton"
    }, {
      template: _withCtx(() => [
        (!_unref(isMobile))
          ? (_openBlock(), _createBlock(IconTemplate, {
              key: 0,
              class: "header-logo-icon-desktop",
              height: "60",
              name: "logo",
              width: "200"
            }))
          : (_openBlock(), _createBlock(IconTemplate, {
              key: 1,
              class: "header-logo-icon-table",
              height: "32",
              name: "logo",
              width: "110"
            })),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: landingLink.value,
              class: "header__skeleton-back-page"
            }, [
              _createVNode(IconTemplate, {
                class: "header__skeleton__back-icon",
                height: "12",
                name: "back",
                width: "12"
              }),
              _hoisted_3
            ], 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("a", {
              key: 3,
              href: landingLink.value,
              class: "header__skeleton-back-icon"
            }, [
              _createVNode(IconTemplate, {
                class: "header__skeleton-cross-icon",
                height: "13",
                name: "removed",
                width: "13"
              })
            ], 8, _hoisted_4))
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})